export enum Constants {
  HISTORY_SET_ITEMS = 'HISTORY_SET_ITEMS',
  HISTORY_SET_TOTAL = 'HISTORY_SET_TOTAL',
  HISTORY_SET_LOADING = 'HISTORY_SET_LOADING'
}